// @flow

import * as React from 'react';
import PropTypes from 'prop-types';

import { lighten, styled } from '@mui/material/styles';

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';

import ColumnPicker from './ColumnPicker';

const StyledToolbar = styled(Toolbar, {
  shouldForwardProp: (prop) => prop !== 'highlighted'
})(({ theme, highlighted }) => ({
  paddingRight: theme.spacing(1),

  ...(highlighted
    ? theme.palette.mode === 'light'
      ? {
          color: theme.palette.secondary.dark,
          backgroundColor: lighten(theme.palette.secondary.light, 0.4)
        }
      : {
          color: lighten(theme.palette.secondary.light, 0.4),
          backgroundColor: theme.palette.secondary.dark
        }
    : {})
}));

const Title = styled('div')({
  flex: '0 0 auto'
});

const Spacer = styled('div')({
  flex: '1 1 100%'
});

const Actions = styled('div')(({ theme }) => ({
  color: theme.palette.text.secondary,
  display: 'flex'
}));

const EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    title,
    i18n,
    columnData,
    onRequestVisibleColumns
  } = props;

  return (
    <StyledToolbar highlighted={numSelected > 0}>
      <Title>
        {numSelected > 0 ? (
          <Typography variant="subtitle1">
            {i18n('% selected', numSelected)}
          </Typography>
        ) : title ? (
          <Typography variant="h6">{title}</Typography>
        ) : null}
      </Title>

      <Spacer />

      <Actions>
        {numSelected > 0 ? (
          <Tooltip title={i18n('Delete')}>
            <IconButton aria-label={i18n('Delete')}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <ColumnPicker
            toggleColumn={(columnId, visible) => {
              onRequestVisibleColumns(
                visible
                  ? [...props.visibleColumns, columnId]
                  : props.visibleColumns.filter(
                      (visibleColumn) => visibleColumn !== columnId
                    )
              );
            }}
            columns={columnData}
            visibleColumns={props.visibleColumns}
          />
        )}
      </Actions>
    </StyledToolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  i18n: PropTypes.func.isRequired,
  title: PropTypes.string
};

export default EnhancedTableToolbar;
